import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import useShow from '../../../hooks/useShow';
import {getEventGroups, getEventTickets} from '../../../redux/tickets/ticketsActions';
import store from '../../../store';
import PageWrapper from '../../components/pageWrapper/PageWrapper';
import TicketsArea from './ticketsArea/TicketsArea';
import TicketsPopupContent from '../ticketsPopUp/basicTicket/ticketsPopupContent/TicketsPopupContent';
import NoTicketsScreen from '../components/noTicketsScreen/NoTicketsScreen';
import Loader from '../../../component/loader/Loader';
import {Else, If, Then} from 'react-if';
import {POPUP_DURATION} from '../../../globalVariables/GlobalVariables';
import {add, cardsPreview,  op,  tablePreview} from '../../../assets/symbols/symbols/Symbols.css';
import getTicketsIconList, {ticketOptionsCssStyle} from '../functions/getTicketsIconList';
import useMobile from '../../../hooks/useMobile';
import TableContext from '../../components/tableContext/TableContext';
import setGlobalState from '../../../redux/setGlobalState';
import {hasAccountAccess} from '../../../functions/permission';

function Tickets() {
    const {t} = useTranslation('ticket');
    const {tickets,getEventTicketsXHR,ticketsIcon,getEventGroupsXHR} = useSelector(s => s.tickets);
    const eventType = useSelector(s => s.event?.type);
    const location = useLocation();
    const [ticket, setPopUp] = useState({});
    const popShow = useShow(POPUP_DURATION);
    const [isTablePreview,setIsTablePreview]=useState(tickets?.length>4?true:false);
    const previewList={table:{icon:cardsPreview,text:t('cardsPreview')},cards:{icon:tablePreview,text:t('tablePreview')}};
    const currentPreview = previewList[isTablePreview?'table':'cards'];

    const ticketsOperations = [{
        key: 0, text: t('newTicket'), onClick: () => {
            newTicket();
        }, icon: add
    },
    ...((eventType==='ticket' && hasAccountAccess('scheduled'))?[{
        key: 1, text: t('scheduledTicket'), onClick: () => {
            setGlobalState('ui.event.isScheduled',true);
        },
        withoutPlus: true
    }] : [])];
    const iconOperations = [{
        key: 1, icon:currentPreview?.icon,tooltipText:currentPreview?.text,color:'transparent', onClick: () => {
            setIsTablePreview(!isTablePreview);
        }
    }];
    const optionsList = getTicketsIconList(ticketsIcon,t);
    const operations={buttons: ticketsOperations,
        icons: iconOperations,
        optionsList:optionsList,
        cssStyle: ticketOptionsCssStyle
    };
    const mobileActions =  [
        ...ticketsOperations,
        {text: t('changeIcons'), icon: op, list: {...optionsList, arr: optionsList.list}}
    ];

    const newTicket = () => {
        setPopUp({});
        popShow.open();
    };
    const openPopUp = (ticket) => {
        setPopUp(ticket);
        popShow.open();
    };

    useEffect(() => {
        const fetchData = async () => {
            if(!store.getState().tickets.tickets.length){
                getEventTickets().then(t=>{
                    if(t.length>4)
                        setIsTablePreview(true);
                });
            }
            if(!getEventGroupsXHR)
                await getEventGroups();
        };
        fetchData()
            .catch(console.error);
        if(location.state?.openNewTicket) {
            newTicket();
        }
    }, []);

    const isMobile=useMobile();

    useEffect(()=>{
        if(isMobile&&!isTablePreview)
            setIsTablePreview(true);
    },[isMobile]);

    return (
        <TableContext data={tickets} searchColumns={['countExtra', 'price', 'title', 'soldPrice', 'sold']}>
            <PageWrapper image={'ticketsGroups'} operations={operations} className={'ticketsGroups'} mobileActions={mobileActions}>
                {<>
                    <If condition={tickets.length}>
                        <Then>
                            <TicketsArea tickets={tickets} isTablePreview={isTablePreview} openPop={(ticket) => openPopUp(ticket)}/>
                        </Then>
                        <Else>
                            <If condition={getEventTicketsXHR === 'SUCCESS'}>
                                <Then>
                                    <NoTicketsScreen onClick={newTicket}/>
                                </Then>
                                <Else>
                                    <Loader XHR={getEventTicketsXHR || 'LOADING'} height="100%">{null}</Loader>
                                </Else>
                            </If>
                        </Else>
                    </If>
                    {popShow.isOpen && <TicketsPopupContent tid={ticket?.tid} close={popShow.close} showClass={popShow.showClass}/>}
                </>}
            </PageWrapper>
        </TableContext>
    );
}

export default Tickets;
